import { EventsBySportIdRequest } from "sb-bff-integration";
import { ActiveRequestsType } from "../../typings";
import { EntityType } from "sbtech-sports-data-api-contracts";
export const isEntityFromType = (entity, requestType, events) => {
    let entityType = getEntityType(entity, events);
    return entityType === getTypeByRequest(requestType);
};
const getEntityType = (entity, events) => {
    if (entity.entityType === EntityType.Event || entity.entityType === EntityType[EntityType.Event]) {
        return entity.type;
    }
    if (entity.entityType === EntityType.Market || entity.entityType === EntityType[EntityType.Market]) {
        let isOutrightMarket = events.find(e => e.id === entity.id) !== undefined;
        return isOutrightMarket
            ? EventsBySportIdRequest.EventTypesEnum.Outright
            : EventsBySportIdRequest.EventTypesEnum.Fixture;
    }
    return "";
};
const getTypeByRequest = (requestType) => {
    return requestType === ActiveRequestsType.outrights
        ? EventsBySportIdRequest.EventTypesEnum.Outright
        : EventsBySportIdRequest.EventTypesEnum.Fixture;
};
//# sourceMappingURL=isEntityFromType.js.map